export default __webpack_public_path__ + "static/media/billy-taking-notes.f010d81a.png";